module.exports = __webpack_public_path__ + "img/will_d.f8844e06.png";